import { render, staticRenderFns } from "./OHtmlArea.vue?vue&type=template&id=5773d5fc&scoped=true&"
import script from "./OHtmlArea.vue?vue&type=script&lang=js&"
export * from "./OHtmlArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5773d5fc",
  null
  
)

export default component.exports